// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bQvnc","colMin":"styles_colMin__3JTO3"};